/**
 * Async function for fetching and building eligibility classes export data
 */

import { logger } from "@platform/browser-logger";

import { buildClassesRows } from "./builder";

import type { AxiosInstance } from "axios";
import type { ExcelRow } from "../rates";
import type { BenefitClass, Coverage } from "./builder";

const fetchBenefitClasses = async (
  rfpId: string,
  axiosInstance: AxiosInstance,
): Promise<BenefitClass[]> => {
  logger.debug("[btx export] Fetching benefit classes", { rfpId });

  const response = await axiosInstance.get<BenefitClass[]>(
    "/btx/v1/benefit-classes",
    {
      params: {
        rfpId,
        include: "coverages",
      },
    },
  );

  return response.data;
};

/**
 * Fetches benefit classes and builds export rows
 */
export const fetchAndBuildClassesData = async (
  rfpId: string,
  coverages: Coverage[],
  axiosInstance: AxiosInstance,
): Promise<ExcelRow[]> => {
  const benefitClasses = await fetchBenefitClasses(rfpId, axiosInstance);
  const rows = buildClassesRows(benefitClasses, coverages);

  return rows;
};
